import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button, F0Dialog, F0TagStatus } from '@factorialco/f0-react'
import {
  AlertCircleLine,
  ChevronRight,
  DottedCircle,
  ExternalLink,
} from '@factorialco/f0-react/icons/app'
import { UpsellLandingPage } from 'generated/resources/graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { useMarketplaceModulesPath } from 'modules/marketplace_modules/hooks/useMarketplaceModulesPath'
import ModulesSection from 'modules/upsell/components/ModulesSection'

export const OnePromoFooter = ({ content }: { content: UpsellLandingPage | undefined }) => {
  const [howItWorksModal, setHowItWorksModal] = useState(false)
  const navigate = useNavigate()
  const { getListPath } = useMarketplaceModulesPath()

  const section = content?.sections?.at(1)
  return (
    <>
      <Box
        style={{
          background:
            'linear-gradient(270deg, rgba(161, 173, 229, 0.12) 0%, rgba(229, 25, 67, 0.12) 50%, rgba(229, 86, 25, 0.12) 100%)',
          paddingBottom: '60px',
          marginRight: '-25px',
          marginLeft: '-25px',
        }}
        padding="s80"
        className="flex flex-row items-center justify-between"
      >
        <Box className="flex flex-col gap-4" width="s400">
          <Box width="fit-content">
            <F0TagStatus text={content?.tagLabel || '-'} variant="warning" />
          </Box>
          <Text size="500" color="black" weight="bold">
            {section?.title || ''}
          </Text>
          <Text size="400">{section?.description || ''}</Text>
          <Box className="flex flex-row gap-2">
            <F0Button
              label={section?.buttonLabel || 'Explore more'}
              onClick={() => {
                track(trackingEvents.upsell.clickExploreMore, {
                  component: 'one_promo_footer',
                })
                navigate(getListPath('upsell_origin=one_promo'))
              }}
            />
            <F0Button
              label={content?.sections?.at(2)?.buttonLabel || 'How it works'}
              variant="ghost"
              icon={AlertCircleLine}
              onClick={() => {
                setHowItWorksModal(true)
              }}
            />
          </Box>
        </Box>
        <Box style={{ width: '500px' }}>
          <ModulesSection origin="one_promo" />
        </Box>
      </Box>
      <HowItWorksModal isOpen={howItWorksModal} onClose={() => setHowItWorksModal(false)} />
    </>
  )
}

const HowItWorksModal = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
  const navigate = useNavigate()
  const { getListPath } = useMarketplaceModulesPath()

  return (
    <F0Dialog
      isOpen={isOpen}
      onClose={onClose}
      position="center"
      title={i18n.t('growth.one_waitlist.one_promo.how_it_works_modal.title')}
      secondaryAction={{
        label: i18n.t('growth.one_waitlist.one_promo.how_it_works_modal.steps.button_label'),
        onClick: onClose,
      }}
    >
      <Box className="flex flex-col gap-4">
        <Text size="200">
          {i18n.t('growth.one_waitlist.one_promo.how_it_works_modal.description')}
        </Text>
        <Box key="step_1" className="flex flex-row gap-1">
          <Box className="flex items-center gap-1">
            <DottedCircle className="w-5 h-5" />
            <div style={{ borderLeft: '2px solid #05234824', height: '86px' }}></div>
          </Box>
          <Box className="flex gap-2 ">
            <Box className="flex flex-col">
              <Text size="200" weight="bold" color="black">
                {i18n.t('growth.one_waitlist.one_promo.how_it_works_modal.steps.step_1.title')}
              </Text>
              <Text size="200">
                {i18n.t(
                  'growth.one_waitlist.one_promo.how_it_works_modal.steps.step_1.description'
                )}
              </Text>
            </Box>
            <Box width="fit-content">
              <F0Button
                label={i18n.t(
                  'growth.one_waitlist.one_promo.how_it_works_modal.steps.step_1.button_label'
                )}
                onClick={() => {
                  track(trackingEvents.upsell.clickExploreMore, {
                    component: 'one_promo_how_it_works_modal',
                  })
                  navigate(getListPath('upsell_origin=one_promo'))
                }}
                icon={ExternalLink}
                size="sm"
              />
            </Box>
          </Box>
        </Box>

        <Box key="step_2">
          <Box key="step_1" className="flex flex-row gap-1">
            <ChevronRight className="w-5 h-5" />
            <Box className="flex flex-col gap-1">
              <Text size="200" weight="bold" color="black">
                {i18n.t('growth.one_waitlist.one_promo.how_it_works_modal.steps.step_2.title')}
              </Text>
              <Text size="200">
                {i18n.t(
                  'growth.one_waitlist.one_promo.how_it_works_modal.steps.step_2.description'
                )}
              </Text>
            </Box>
          </Box>
        </Box>

        <Box key="step_3">
          <Box key="step_1" className="flex flex-row gap-1">
            <ChevronRight className="w-5 h-5" />
            <Box className="flex flex-col gap-1">
              <Text size="200" weight="bold" color="black">
                {i18n.t('growth.one_waitlist.one_promo.how_it_works_modal.steps.step_3.title')}
              </Text>
              <Text size="200">
                {i18n.t(
                  'growth.one_waitlist.one_promo.how_it_works_modal.steps.step_3.description'
                )}
              </Text>
            </Box>
          </Box>
        </Box>
      </Box>
    </F0Dialog>
  )
}
